import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './carousel.scss';

export function CustomCarousel({imagesURL}) {

    return (
        <Carousel controls='false'>
            {
                imagesURL.map(
                    (imageURL, index) => {
                        return (
                            <Carousel.Item key={`${imageURL}-${index}`}>
                                <img src={imageURL} alt='' loading="lazy" decoding="async" />
                            </Carousel.Item>
                        )
                    }
                )
            }
        </Carousel >
    )
}